/*
 * Bundle builder for the Vitamin D Gummies PDP.
 * Cards represent real product variants. Selecting a card clicks the
 * matching (visually hidden) native variant radio so Dawn's own
 * variant-switching logic keeps the hero price, hidden form variant id
 * and cart perfectly in sync with what's shown here.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('bundle-builder').forEach(initBundleBuilder);
});

function initBundleBuilder(root) {
  const variantSelects = document.getElementById(root.dataset.targetVariantSelects);
  const formId = root.dataset.targetForm;
  const wrapper = root.closest('.pdp-container') || root.parentElement;
  const summaryTotal = wrapper.querySelector('[data-bundle-summary-total]');
  const summarySave = wrapper.querySelector('[data-bundle-summary-save]');
  const addButton = wrapper.querySelector('[data-bundle-add-to-cart]');
  const cards = Array.from(root.querySelectorAll('[data-bundle-card]'));

  function selectCard(card) {
    cards.forEach((c) => {
      c.classList.remove('is-selected');
      c.setAttribute('aria-pressed', 'false');
    });
    card.classList.add('is-selected');
    card.setAttribute('aria-pressed', 'true');

    const priceEl = card.querySelector('[data-bundle-card-price]');
    const priceHtml = priceEl ? priceEl.innerHTML : '';
    if (summaryTotal) summaryTotal.innerHTML = priceHtml;

    const saveEl = card.querySelector('.pdp-bundle-card__save');
    if (summarySave) summarySave.textContent = saveEl ? saveEl.textContent : '';

    if (variantSelects) {
      const value = card.dataset.variantValue;
      const input = variantSelects.querySelector(
        'input[type="radio"][value="' + CSS.escape(value) + '"]'
      );
      if (input && !input.checked) {
        input.click();
      }
    }

    document.dispatchEvent(
      new CustomEvent('pdp:bundle-select', {
        detail: { variantId: card.dataset.variantId, priceHtml },
      })
    );
  }

  cards.forEach((card) => {
    card.addEventListener('click', () => selectCard(card));
  });

  if (addButton) {
    addButton.addEventListener('click', () => {
      const form = document.getElementById(formId);
      if (form) form.requestSubmit();
    });
  }
}
